export const SENTRY_MODULE_OPTIONS = Symbol('SentryModuleOptions');
export const SENTRY_TOKEN = Symbol('SentryToken');